module.exports = "<img src=\"/assets/images/404.png\"/>\n"